export const black = '#000'
export const white = '#FFF'
export const backgroundColor = 'rgba(229,229,229,0.24)'
export const darkGray = 'rgb(40,40,42,1)'
export const gray = 'rgba(79,79,79,1)'
export const orangeSelected = '#F05A2633'
export const orange = '#F05A26'
export const orangeSemitransparent = '#F05A2626'
export const lightGray = 'rgba(189,189,189,1)'
export const normalGray = 'rgba(130,130,130,1)'
export const green = 'rgba(80,213,173,1)'
export const red = 'rgba(255,74,74,1)'
export const yellow = 'rgba(255,212,62,1)'
export const lighterGray = 'rgba(228,228,228,0.2)'
export const grayMelange = 'rgba(64,64,66,1)'
export const lightergray2 = 'rgba(225,225,225,1)'
export const lightergray3 = 'rgba(242,242,242,1)'
export const lightOrange = 'rgba(240, 90, 38, 0.04)'
export const lightOrange2 = 'rgba(240, 90, 38, 0.5)'
export const lightergray4 = 'rgba(228,228,228,1)'
export const lightOrangeSolid = '#FEF0EC'
